// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1w4da","actions":"GroupTable_actions__1BY0N","deleteModalFooter":"GroupTable_deleteModalFooter__3XISA"};